// Two generators write into this bucket under DIFFERENT naming rules, on purpose:
//
//   MMS createMonogram (Shopify webhook)  `${font}-${text}-${mainCol}-${backCol}-undefined`
//                                          raw spaces, empty parts kept, trailing
//                                          `-undefined` from an absent `small` param
//   MonogramService (this app's backend)   buildMonogramFilename() — spaces to dashes,
//                                          empty parts dropped, no `-undefined`
//
// Do not "unify" one side without the other: this builder reconstructs the MMS name, and
// it is only ever reached when monogram_url is absent — which is exactly the case where
// the webhook wrote the file and nothing recorded a URL for it. Items this app generated
// carry monogram_url and never come through here.
export const getLegacyMonogramPdfUrl = (lineItem) => {
  const font = lineItem.monogram_font.toLowerCase();
  const text = encodeURIComponent(lineItem.monogram_text);
  const color = lineItem.monogram_color;
  const shadow = lineItem.monogram_shadow || '';
  const ipcSuffix = lineItem.sku.startsWith('IPC')
    ? `-IPC-${lineItem.monogram_position}`
    : '';
  const botSuffix = lineItem.sku.startsWith('BOT') && lineItem.monogram_position === 'Top'
    ? '-Lid'
    : '';

  return [
    'https://storage.googleapis.com/july-monogramming-management.appspot.com/',
    `${font}-${text}-${color}-${shadow}-undefined`,
    ipcSuffix,
    botSuffix,
    '.pdf?avoidTheCaches=1',
  ].join('');
};

export const getMonogramPdfUrl = (lineItem) => lineItem.monogram_url || getLegacyMonogramPdfUrl(lineItem);
